<template>
    <div>
        <div class="controls">
            <sui-button @click="flushCache" icon="bolt" basic color="orange">Flush</sui-button>
            <sui-button @click="reload" icon="sync" basic>Reload</sui-button>
        </div>

        <sui-tab :menu="{ secondary: true }">
            <cache-customers :data="customers" title="Customers" />
            <cache-devices :data="devices" title="Devices" />
            <cache-clients :data="clients" title="Clients" />
            <cache-subscriptions :data="subscriptions" title="Subscriptions" />
            <sui-tab-pane title="Raw" :attached="false">
                <json-viewer class="json-viewer" :value="cache" :expand-depth="1" copyable />
            </sui-tab-pane>
        </sui-tab>
    </div>
</template>

<script>
  import JsonViewer from 'vue-json-viewer'
  import CacheCustomers from "./cache/CacheCustomers";
  import CacheDevices from "./cache/CacheDevices";
  import CacheClients from "./cache/CacheClients";
  import CacheSubscriptions from "./cache/CacheSubscriptions";
  export default {
    name: "Cache",
    components: {
      CacheSubscriptions,
      CacheClients,
      CacheDevices,
      CacheCustomers,
      JsonViewer
    },
    mounted() {
      this.reload()
    },
    computed: {
      cache: function() {
        return (this.$store.state.admin.cache || {})
      },
      customers: function () {
         return this.cache.Customers || []
      },
      devices: function() {
        return this.cache.Devices || []
      },
      clients: function() {
        return this.cache.Clients || []
      },
      subscriptions: function() {
        return this.cache.Subscriptions || []
      },
      detailedCustomers: function() {
        return this.cache.DetailedCustomers || []
      }
    },
    methods: {
      async flushCache() {
        await this.$store.dispatch('admin/flushCache')
        this.reload()
      },
      async reload() {
        await this.$store.dispatch('admin/loadCache')
      }
    }
  }
</script>

<style scoped>
    .controls {
        float: right;
        margin-right: 10pt;
    }
    .json-viewer {
        zoom: 0.8;
    }

</style>